import React, { useState } from 'react';
import { SparkleEffect } from './components/SparkleEffect';
import { Header } from './components/Header';
import { TopFans } from './components/TopFans';
import { BlogSection } from './components/BlogSection';
import { FanFictionSection } from './components/FanFictionSection';
import { SecretSection } from './components/SecretSection';
import { Footer } from './components/Footer';
export function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  // Set the page title
  if (typeof document !== 'undefined') {
    document.title = "~*~ CeDrInE DiOn's #1 FaN pAgE ~*~";
  }
  return <div className={`min-h-screen w-full py-8 px-4 flex flex-col items-center relative transition-colors duration-700 ${isDarkMode ? 'dark-mode selection:bg-red-600 selection:text-white' : 'selection:bg-[#ff1493] selection:text-white'}`} data-id="element-0">
      {!isDarkMode && <SparkleEffect data-id="element-1" />}

      <main className="w-full max-w-5xl flex flex-col items-center z-10" id="home" data-id="element-2">
        <Header data-id="element-3" />
        <TopFans data-id="element-4" />
        <BlogSection data-id="element-5" />
        <FanFictionSection data-id="element-6" />
        <SecretSection onAuthenticated={() => setIsDarkMode(true)} data-id="element-7" />
        <Footer data-id="element-8" />
      </main>
    </div>;
}